<div class="header-bar-wrapper">
  <div class="header-bar" [class.ghost]="routeRecommendation == null">
    <div class="flex flex-wrap grid-gap-10 w-100" [ngClass]="isVME ? 'mt-2' : ''">
      <div class="flex-grow-1 flex grid-gap-10 align-items-center">
        <div class="flex-shrink-1 white-space-nowrap cursor-pointer" (click)="goBack()">
          <i class="fa fa-angle-left"></i> Back
        </div>

        <div
          class="flex-shrink-1 ghost-inline job-number white-space-nowrap"
          *ngIf="!noLongerAvailable"
        >
          Route {{ routeRecommendation?.routeNumber }}:
          {{ routeRecommendation?.supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
          <span
            class="price-increase-pill ml-2"
            *ngIf="routeRecommendation?.priceIncreasePercentage > 0"
          >
            Increased by {{ routeRecommendation.priceIncreasePercentage }}%
          </span>
        </div>

        <grab-bonus-badge
          *ngIf="!noLongerAvailable && grabBonusCount > 0"
          [count]="grabBonusCount"
          [width]="100"
        ></grab-bonus-badge>
      </div>

      <div class="flex-shrink-1">
        <div
          class="flex align-items-center grid-gap-5 flex-wrap"
          *ngIf="!routeRecommendation?.routeGrabbed && routeRecommendation && !isVME"
        >
          <button
            class="pull-right ui-button ui-button-secondary"
            type="button"
            label="Hide"
            pButton
            (click)="showRejectionReasonDialog = true"
            *ngIf="!routeRecommendation?.hidden"
          ></button>
          <button
            class="pull-right ui-button ui-button-secondary"
            type="button"
            label="UnHide"
            pButton
            (click)="unHideRoute()"
            *ngIf="routeRecommendation?.hidden"
          ></button>
          <button
            class="pull-right ui-button ui-button-secondary"
            type="button"
            label="Watch"
            pButton
            (click)="watchRoute()"
            *ngIf="!routeRecommendation?.watched"
          ></button>
          <button
            class="pull-right ui-button ui-button-secondary"
            type="button"
            label="Remove from Watched"
            pButton
            (click)="unwatchRoute()"
            *ngIf="routeRecommendation?.watched"
          ></button>
          <button
            class="pull-right ui-button"
            type="button"
            [label]="grabRouteLabel()"
            (click)="onGrabRouteClick()"
            [disabled]="grabbingRoute"
            pButton
          ></button>
        </div>
      </div>
    </div>
  </div>
  <app-tab-scroller
    [tabs]="tabs"
    (tabSelected)="onTabSelected($event)"
    *ngIf="!noLongerAvailable"
  ></app-tab-scroller>
</div>

<div [hidden]="activeViewId !== 'scroll'" *ngIf="!noLongerAvailable">
  <div class="content-container mt-3 pt-2 scroll-id job-screen-container mt-3" id="routeOverview">
    <h2 class="sub-header-bar">Route Overview</h2>
    <div *ngIf="routeRecommendation">
      <route-job-screen-route-tasks
        [routeId]="routeRecommendation?.id"
      ></route-job-screen-route-tasks>
    </div>
  </div>

  <div class="content-container mt-3 pt-2 scroll-id job-screen-container" id="taskDetails">
    <h2 class="sub-header-bar">Task Details</h2>
    <div>
      <route-job-screen-tasks
        [routeId]="routeId"
        *ngIf="routeRecommendation"
      ></route-job-screen-tasks>
    </div>
  </div>
</div>

<div *ngIf="activeViewId === 'routeItinerary' && routeId && !noLongerAvailable">
  <route-recommendation-detailed-view
    [routeRecommendationId]="routeId"
  ></route-recommendation-detailed-view>
</div>

<div
  *ngIf="noLongerAvailable"
  style="height: calc(100vh - 55px)"
  class="flex flex-column justify-content-center"
>
  <div class="p-4 text-center" style="font-size: 30px">
    Apologies, this route is no longer available
  </div>
  <div class="p-4 text-center link-style">
    <span (click)="goBack()" class="hover:text-blue-700 back-to-search" style="cursor: pointer"
      >Back to Search</span
    >
  </div>
</div>

<route-hide-reason-dialog
  (onConfirmHide)="onConfirmHide($event)"
  [(visible)]="showRejectionReasonDialog"
>
</route-hide-reason-dialog>

<p-confirmDialog
  [key]="routeRecommendation?.id?.toString()"
  header="Confirmation"
></p-confirmDialog>

<route-itinerary-confirmation-popup
  *ngIf="showConfirmationPopup"
  [(showConfirmationDialog)]="showConfirmationPopup"
  [jobId]="this.routeRecommendation.jobId"
  [isVME]="isVME"
>
</route-itinerary-confirmation-popup>
